export const INSCRIPTION = "/";
export const NOWHERE = "/*";
export const LOGIN = "/login";
export const SEARCH = "/chercher";
export const FINALISE = "/finaliser";
export const DASHBOARD = "/dashboard";
export const VALIDATIONS = "/validations";
export const INVITATIONS = "/invitations";
export const INVITATION_ERROR = "/invitation-error";
